module.exports = __webpack_public_path__ + "media/educators/educator-landing-hero@2x-af2e438e.jpg";